import { useCallback, useState } from 'react';
import { useTranslation } from '@ibk/shared-translation';
import { buildPatFacilitatorClipboardText } from './patFacilitatorClipboard';
export function usePatFacilitatorCopy() {
    const { t } = useTranslation();
    const [showCopyAlert, setShowCopyAlert] = useState(false);
    const registrationLabel = t('recharge.pat-facilitator.registration-label');
    const corporateNameLabel = t('recharge.pat-facilitator.corporate-name-label');
    const cnpjLabel = t('recharge.pat-facilitator.cnpj-label');
    const handleCopy = useCallback(async () => {
        try {
            await navigator.clipboard.writeText(buildPatFacilitatorClipboardText({
                registration: registrationLabel,
                corporateName: corporateNameLabel,
                cnpj: cnpjLabel,
            }));
            setShowCopyAlert(true);
        }
        catch (error) {
            console.error('Erro ao copiar dados PAT:', error);
        }
    }, [cnpjLabel, corporateNameLabel, registrationLabel]);
    const handleCloseCopyAlert = useCallback(() => {
        setShowCopyAlert(false);
    }, []);
    return {
        registrationLabel,
        corporateNameLabel,
        cnpjLabel,
        showCopyAlert,
        handleCopy,
        handleCloseCopyAlert,
    };
}
